/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { ICON_MENU_OPEN } from '@squiz/sds';
import clsx from 'clsx';
import React, { useMemo } from 'react';
import { FILE_EXPLORER_DATA_IDS } from '../../../../../../Constants/DataIDs.constants';
import { useFileExplorerStore } from '../../FileExplorer.state';

export const FileExplorerPath = (): JSX.Element => {
  const { fileExplorerPosition, setStagedFileExplorerPosition } = useFileExplorerStore();
  const pathOptions = useMemo(() => {
    const pathParts = fileExplorerPosition.split('/').filter((part) => part !== '');
    const pathOptions = pathParts.map((part, index) => {
      const path = pathParts.slice(0, index + 1).join('/');
      return {
        action: (): void => setStagedFileExplorerPosition(`/${path}/`),
        label: part.replace(/\+/g, ' '),
      };
    });
    return pathOptions;
  }, [fileExplorerPosition, setStagedFileExplorerPosition]);

  const handleRootButton = (): void => {
    if (fileExplorerPosition === '/') {
      return;
    }
    setStagedFileExplorerPosition('/');
  };

  return (
    <ol className="file-explorer__path">
      <li className={clsx('file-explorer__path-item file-explorer__path-item--root')}>
        <button data-id={FILE_EXPLORER_DATA_IDS.breadcrumbLinkRoot} onClick={() => handleRootButton()} title="Root">
          {ICON_MENU_OPEN}
        </button>
      </li>
      {pathOptions.map((pathOption, index) => {
        const { action, label } = pathOption;
        if (index === pathOptions.length - 1) {
          return (
            <li className="file-explorer__path-item current" key={index}>
              <span className="file-explorer__path-link">{label}</span>
            </li>
          );
        }
        return (
          <li className="file-explorer__path-item" key={index}>
            <button
              className="file-explorer__path-link"
              data-id={FILE_EXPLORER_DATA_IDS.breadcrumbLink}
              onClick={action}
              title={label}
            >
              {label}
            </button>
          </li>
        );
      })}
    </ol>
  );
};
